import type { SelectProps } from "@mui/material/Select";

/**
 * Root stacking order for picker `Popover` components when used inside the
 * display editor canvas, where selected nodes use z-index values around 1e6.
 *
 * Keeps popovers above the selection overlay while remaining below the editor
 * context menu (`EDITOR_CONTEXT_MENU_Z_INDEX`).
 */
export const EDITOR_PICKER_POPOVER_Z_INDEX = 1_500_000;

/**
 * Stacking order for `Select` menus portaled from inside picker popovers.
 * Must stay above {@link EDITOR_PICKER_POPOVER_Z_INDEX}.
 */
export const EDITOR_PICKER_MENU_Z_INDEX = EDITOR_PICKER_POPOVER_Z_INDEX + 100;

/**
 * Stacking order for nested picker popovers (e.g. `ColorPicker` inside another
 * picker). Must stay above {@link EDITOR_PICKER_MENU_Z_INDEX}.
 */
export const EDITOR_PICKER_NESTED_POPOVER_Z_INDEX =
  EDITOR_PICKER_MENU_Z_INDEX + 100;

/** Shared `MenuProps` for MUI `Select` used inside editor picker popovers. */
export const editorPickerSelectMenuProps: NonNullable<
  SelectProps["MenuProps"]
> = {
  slotProps: {
    root: {
      sx: { zIndex: EDITOR_PICKER_MENU_Z_INDEX },
    },
  },
};

/** Above behavior node selection overlays (~1e6) and the scene catalog side panel. */
export const EDITOR_CONTEXT_MENU_Z_INDEX = 2_000_000;
